(function(){
  document.addEventListener('click',function(event){
    const link=event.target.closest&&event.target.closest('a');
    if(!link)return;
    const care=link.closest('.bm-tw-details__care,.bm-adapt-details__care,.bm-sf-details__care');
    const delivery=link.closest('.bm-compact-overview__support,.bm-sf-overview__support')&&link.getAttribute('href')==='/pages/shipping-returns';
    if(!care&&!delivery)return;
    if(care&&(link.getAttribute('href')==='/pages/all-locations'||/find your bedding mart store/i.test(link.textContent)))return;
    if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const mobile=window.matchMedia('(max-width:767px)').matches;
    const availableWidth=window.screen.availWidth||window.innerWidth;
    const availableHeight=window.screen.availHeight||window.innerHeight;
    const availableLeft=window.screen.availLeft||0;
    const availableTop=window.screen.availTop||0;
    const width=Math.min(900,mobile?window.innerWidth:Math.max(1,availableWidth-32));
    const height=Math.min(900,mobile?window.innerHeight:Math.max(1,availableHeight-48));
    const left=Math.round(Math.min(availableLeft+availableWidth-width,Math.max(availableLeft,window.screenX+(window.outerWidth-width)/2)));
    const top=Math.round(Math.min(availableTop+availableHeight-height,Math.max(availableTop,window.screenY+(window.outerHeight-height)/2)));
    const popup=window.open(link.href,'bmProductSupport','popup=yes,width='+width+',height='+height+',left='+left+',top='+top+',scrollbars=yes,resizable=yes');
    if(popup){event.preventDefault();event.stopImmediatePropagation();popup.opener=null;popup.focus();}
  },true);
})();